import React from "react";
import Script from "react-load-script";
import radium from "radium";
import mq from "backpack-ui/dist/styles/mq";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import DotLoader from "backpack-ui/dist/components/dotLoader";
import colors from "backpack-ui/dist/styles/colors";

const styles = {
  container: {
    position: "relative",
    marginBottom: "48px",
  },
  label: {
    color: colors.accentRed,
    marginBottom: "8px",
  },
  sponsor: {
    position: "absolute",
    bottom: "3px",
    right: 0,
    display: "flex",
    alignItems: "center",
    fontSize: "10px",

    [`@media (max-width: ${mq.max["480"]})`]: {
      left: 0,
      right: "auto",
      bottom: "-48px",
    },
  },
  sponsorImage: {
    height: "40px",
  },
  loadingContainer: {
    textAlign: "center",
    backgroundColor: "#f6f6f6",
    height: "295px",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    display: "flex",
  },
  loadText: {
    fontSize: "12px",
  },
};

class WorldNomadsWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      error: false,
    };
  }

  onError = () => {
    this.setState({ error: true });
  }

  onLoad = () => {
    this.setState({ loaded: true });
  }

  render() {
    return (
      <div
        style={styles.container}
        id="worldNomadsWidget"
      >
        <Script
          url="https://www.worldnomads.com/Partner/GetPartnerWidget?partnerCode=LNYPLT&source=&loadWithPanelExpanded=true&excludeStyles=true"
          onError={this.onError}
          onLoad={this.onLoad}
        />

        <ReactCSSTransitionGroup
          transitionName="fadeIn"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          {!this.state.loaded && !this.state.error &&
            <div key="insurance-loading">
              <div style={styles.loadingContainer}>
                <p style={styles.loadText}>Checking insurance quotes…</p>
                <DotLoader />
              </div>
            </div>
          }
        </ReactCSSTransitionGroup>

        <ReactCSSTransitionGroup
          transitionName="fadeIn"
          transitionAppear
          transitionAppearTimeout={500}
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          {this.state.loaded && !this.state.error &&
            <div key="insurance-loaded">
              <div
                id="wn-insurance-quote-editor"
                className={this.state.loaded && "is-ready"}
              />

              <div style={styles.sponsor}>
                Powered by
                <img
                  style={styles.sponsorImage}
                  src="https://assets.staticlp.com/landing-pages/travel-insurance/world-nomads.png"
                  alt="World Nomads logo"
                />
              </div>
            </div>
          }
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default radium(WorldNomadsWidget);



// WEBPACK FOOTER //
// ./assets/pois/components/worldNomadsWidget/index.jsx